import {
    type FC
} from "react";
import {
    Platform,
    View
} from "react-native";
import type IAnimatedIconPartsProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    ANIMATED_ICON_START_PROGRESS
} from "../../constant";
import useAnimatedIconValue from "../../useAnimatedIconValue";
import AnimatedIconLayer from "../layer";

const AnimatedIconParts: FC<IAnimatedIconPartsProps> = ({
    customTheme,
    isMirrored,
    progress,
    color,
    label,
    nodes,
    plan,
    size
}) => {
    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const currentProgress = useAnimatedIconValue({
        initialValue: ANIMATED_ICON_START_PROGRESS,
        isStatic: Platform.OS === "web",
        progress
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        isMirrored,
        direction,
        size
    });

    const isDecorative = !label;

    return <View
        aria-hidden={isDecorative ? true : undefined}
        role={isDecorative ? undefined : "img"}
        accessible={!isDecorative}
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-label={label}
    >
        <AnimatedIconLayer
            progress={currentProgress}
            customTheme={customTheme}
            parts={plan.parts}
            value={progress}
            color={color}
            nodes={nodes}
            size={size}
        />
    </View>;
};
export default AnimatedIconParts;
